import {
  SET_SIGNUP_FORM,
  RECEIVED_USER_COOKIE,
  RECEIVED_COOKIE_USER
} from './actions'

export default function reducer (state = {
  signUpForm: null,
  userCookie: null,
  cookieUser: null
}, action) {
  switch (action.type) {
    case RECEIVED_COOKIE_USER:
      return {
        ...state,
        cookieUser: action.cookieUser
      }
    case RECEIVED_USER_COOKIE:
      return {
        ...state,
        userCookie: action.userCookie
      }
    case SET_SIGNUP_FORM:
      return {
        ...state,
        signUpForm: action.signUpForm
      }
    default:
      return state
  }
}
